"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Scene = _interopRequireDefault(require("../scene7/Scene7"));
var _error404Module = _interopRequireDefault(require("./error404.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var propTypes = {
  /** Contents of the error */
  children: _propTypes["default"].node,
  /** Link to page to return to */
  returnTo: _propTypes["default"].node
};
var defaultProps = {
  children: undefined,
  returnTo: undefined
};
var nbsp = "\xA0";
var Error404 = function Error404(_ref) {
  var children = _ref.children,
    returnTo = _ref.returnTo;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _error404Module["default"].error404,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
      children: "Hang on"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("h2", {
      children: ["We can\u2019t find the page you\u2019re looking", nbsp, "for."]
    }), children && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _error404Module["default"].children,
      children: children
    }), !children && /*#__PURE__*/(0, _jsxRuntime.jsxs)("h2", {
      children: ["Please return to ", returnTo || /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
        href: "/",
        children: "our homepage"
      }), "."]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Scene["default"], {
      src: "//johnlewis.scene7.com/is/image/JohnLewis/404-lrg-hero-120918",
      smallSrc: "//johnlewis.scene7.com/is/image/JohnLewis/404-sml-hero-130918"
    })]
  });
};
Error404.propTypes = propTypes;
Error404.defaultProps = defaultProps;
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Error404);